export default __webpack_public_path__ + "static/media/business-905.7f0a1db6.png";